var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "909px",
    height: "531px",
    viewBox: "0 0 909 531",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Bg-ebook-header") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "28.5091188%",
    x2: "74.7302882%",
    y2: "65.5962955%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9ECFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#579AF0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-18.0%",
    y: "-27.4%",
    width: "136.0%",
    height: "154.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-40.5%",
    y: "-40.6%",
    width: "181.1%",
    height: "181.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0.0893409229%",
    x2: "91.0689085%",
    y2: "99.9106591%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C72C91",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-29.2%",
    y: "-29.2%",
    width: "158.4%",
    height: "158.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 43.2,
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bg-ebook-header",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.898678
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(-391.000000, -164.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M561.622019,656 C684.264137,656 908.520745,583.531514 978.140559,392.847784 C1047.76037,202.164055 978.140559,0 443.799184,0 C-90.5421921,0 -163.067338,347.671246 339.55882,434.135283 C842.184979,520.59932 438.979901,656 561.622019,656 Z",
    id: "Oval",
    fill: "url(#linearGradient-1)",
    opacity: 0.2927544,
    filter: "url(#filter-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-2",
    fill: "#FFA530",
    opacity: 0.0497785296,
    filter: "url(#filter-3)",
    cx: 964.936801,
    cy: 261.440585,
    rx: 222.063199,
    ry: 221.864717
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy",
    fill: "url(#linearGradient-4)",
    opacity: 0.302860805,
    filter: "url(#filter-5)",
    cx: 945.731336,
    cy: 371.773309,
    rx: 222.063199,
    ry: 221.864717
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewBackground);
export default __webpack_public_path__ + "static/media/ViewBackground.87d9aa88020908ff73b21f07843d8aac.svg";
export { ForwardRef as ReactComponent };